export const convertToFullDateTime = (dateString: string): Date => {
  return new Date(dateString)
}

export const formatDateToISO = (date: Date): string => {
  return date.toISOString().split('T')[0]
}

export const formatToDecimalPlaces = (
  value: string | number | null | undefined,
  decimalPlaces = 2
): string => {
  if (value === null || value === undefined || value === '') {
    return '-'
  }
  const num = typeof value === 'number' ? value : parseFloat(value)
  if (Number.isNaN(num)) {
    return '-'
  }
  return num.toFixed(decimalPlaces)
}
